module.exports = __webpack_public_path__ + "img/root011.2801f36f.png";